interface MarkdownComponentProps {
  node?: any;
  children?: React.ReactNode;
  [key: string]: any;
}

export const markdownComponents: Record<
  string,
  React.FC<MarkdownComponentProps>
> = {
  h1: ({ node, ...props }) => (
    <h1 {...props} className="chat-message-text text-2xl font-semibold pb-3" />
  ),
  h2: ({ node, ...props }) => (
    <h2 {...props} className="chat-message-text text-xl font-semibold pb-3" />
  ),
  h3: ({ node, ...props }) => (
    <h3 {...props} className="chat-message-text text-lg font-semibold pb-3" />
  ),
  ul: ({ node, ...props }) => (
    <ul {...props} className="chat-message-text !list-disc list-inside pb-3 ml-0 text-[1.0rem]" />
  ),
  ol: ({ node, ...props }) => (
    <ol
      {...props}
      className="chat-message-text !list-decimal py-3 text-[1.0rem] ml-4 gap-3 flex flex-col"
    />
  ),
  li: ({ node, ...props }) => <li {...props} className="" />,
  a: ({ node, ...props }) => (
    <a {...props} className="chat-message-text font-bold underline text-[1.0rem]" />
  ),
  p: ({ node, ...props }) => <p {...props} className="chat-message-text text-[1.0rem] pb-3" />,
  // antthinking: ({ node, ...props } ) => <Loading type="tiny" />,
  // "page-spec": ({ node, ...props }) => <div {...props} className="chat-message-text font-bold text-[1.0rem] pb-3" />,
  // "section-spec": ({ node, ...props }) => <div {...props} className="chat-message-text font-bold text-[1.0rem] pb-3" />,
  // "copy-associations": ({ node, ...props }) => <div {...props} className="chat-message-text font-bold text-[1.0rem] pb-3" />,
};
